import React from 'react';
import { Book, Check } from 'lucide-react';
export function TomesContent() {
  const primaria = [{
    t: 'Tomo 1 — 1ro a 3ro',
    title: 'Mi Primera Aventura con las Letras',
    desc: 'Alfabetización inicial, sílabas, vocales y primeras palabras.'
  }, {
    t: 'Tomo 2 — 1ro a 3ro',
    title: 'Leo, Escribo y Aprendo',
    desc: 'Lectura de oraciones, escritura guiada y vocabulario básico.'
  }, {
    t: 'Tomo 3 — 1ro a 3ro',
    title: 'Vocabulario y Uso del Lenguaje',
    desc: 'Palabras nuevas, contexto y comunicación cotidiana.'
  }, {
    t: 'Tomo 4 — 4to a 7mo',
    title: 'Comprensión Lectora Lúdica',
    desc: 'Textos narrativos, inferencias y opinión personal.'
  }, {
    t: 'Tomo 5 — 4to a 7mo',
    title: 'Ortografía Desafiante',
    desc: 'B/V, G/J, acentuación y puntuación en práctica.'
  }, {
    t: 'Tomo 6 — 4to a 7mo',
    title: 'Escritura Creativa y Gramática',
    desc: 'Producción de textos, clases de palabras y conectores.'
  }];
  const secundaria = [{
    t: 'Tomo 1 — 1ro y 2do',
    title: 'Textos que Enganchan',
    desc: 'Comprensión lectora con textos reales, modernos y virales.'
  }, {
    t: 'Tomo 2 — 1ro y 2do',
    title: 'Gramática Sin Dolor',
    desc: 'Sintaxis simplificada, morfología y normativa aplicada.'
  }, {
    t: 'Tomo 3 — 3ro y 4to',
    title: 'Argumentar es Pensar',
    desc: 'Textos de opinión, debate y escritura argumentativa.'
  }, {
    t: 'Tomo 4 — 3ro y 4to',
    title: 'Literatura Real',
    desc: 'Cuento, poesía y teatro con análisis accesible y actual.'
  }, {
    t: 'Tomo 5 — 5to y 6to',
    title: 'Escritura Académica',
    desc: 'Redacción formal, ensayo y producción con criterio.'
  }, {
    t: 'Tomo 6 — 5to y 6to',
    title: 'Lengua para el Mundo Real',
    desc: 'Comunicación digital, medios y ciudadanía lingüística.'
  }];
  const features = ['15 actividades listas para imprimir y entregar', 'Consignas claras que el alumno entiende solo', 'Diseño en blanco y negro optimizado para fotocopiadora', 'Solucionario para corrección rápida', 'Guía docente de uso express', 'Alineado al currículo argentino 2026'];
  return <section className="py-16 bg-blue-50" data-id="element-283">
      <div className="max-w-6xl mx-auto px-4" data-id="element-284">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-285">
          Lo que recibís:
        </h2>

        <div className="grid lg:grid-cols-2 gap-8 mb-16" data-id="element-286">
          {/* PRIMARIA */}
          <div className="bg-white rounded-2xl shadow-lg border-t-8 border-blue-500 overflow-hidden" data-id="element-287">
            <div className="p-6 bg-blue-50 border-b border-blue-100" data-id="element-288">
              <h3 className="text-2xl font-bold text-blue-900 flex items-center gap-2" data-id="element-289">
                <Book className="w-6 h-6" data-id="element-290" /> PRIMARIA — 6 TOMOS
              </h3>
              <p className="text-blue-700 font-medium mt-1" data-id="element-291">
                Para docentes de Lengua de 1° a 7° grado
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-292">
              {primaria.map((item, i) => <div key={i} className="flex gap-4" data-id="element-293">
                  <div className="w-10 h-10 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center font-bold flex-shrink-0" data-id="element-294">
                    {i + 1}
                  </div>
                  <div data-id="element-295">
                    <div className="text-sm font-bold text-blue-600 mb-1" data-id="element-296">
                      {item.t}
                    </div>
                    <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-297">
                      {item.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-298">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* SECUNDARIA */}
          <div className="bg-white rounded-2xl shadow-lg border-t-8 border-green-500 overflow-hidden" data-id="element-299">
            <div className="p-6 bg-green-50 border-b border-green-100" data-id="element-300">
              <h3 className="text-2xl font-bold text-green-900 flex items-center gap-2" data-id="element-301">
                <Book className="w-6 h-6" data-id="element-302" /> SECUNDARIA — 6 TOMOS
              </h3>
              <p className="text-green-700 font-medium mt-1" data-id="element-303">
                Para docentes de Lengua de 1° a 6° año
              </p>
            </div>
            <div className="p-6 space-y-6" data-id="element-304">
              {secundaria.map((item, i) => <div key={i} className="flex gap-4" data-id="element-305">
                  <div className="w-10 h-10 bg-green-100 text-green-700 rounded-lg flex items-center justify-center font-bold flex-shrink-0" data-id="element-306">
                    {i + 1}
                  </div>
                  <div data-id="element-307">
                    <div className="text-sm font-bold text-green-600 mb-1" data-id="element-308">
                      {item.t}
                    </div>
                    <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-309">
                      {item.title}
                    </h4>
                    <p className="text-gray-600" data-id="element-310">{item.desc}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 max-w-4xl mx-auto border border-gray-100" data-id="element-311">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8" data-id="element-312">
            Cada tomo incluye:
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-313">
            {features.map((f, i) => <div key={i} className="flex items-center gap-3" data-id="element-314">
                <div className="bg-blue-100 p-1 rounded-full" data-id="element-315">
                  <Check className="w-5 h-5 text-blue-600" data-id="element-316" />
                </div>
                <span className="text-gray-700 font-medium" data-id="element-317">{f}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}